import React from "react"
import { clone, values, keys } from "lodash"
import PropTypes from "prop-types"
import { Plus, Minus } from "react-feather"

import describePriceAges from "./describePriceAges"

import './Reservation.AgePersons.less'

function calculatePrice(persons, price) {
  const total = keys(persons).reduce((accum, key) => {
    const n = persons[key]
    if (key == "g") {
      return accum + price.general * n
    }
    else {
      const franja = price.agePrices.find(franja => franja.age == key)
      return accum + franja.price * n
    }
  }, 0)

  return total
}

export default class AgePersonsPicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      showMore: false,
    }
  }

  sumContador(key, quantity) {  
    const peopleCount = clone(this.props.value)
    peopleCount[key] = Math.max(0, (this.props.value[key] || 0) + quantity)
    this.props.onChange(peopleCount)
  }


  getTotalPersons() {
    return values(this.props.value).reduce((accum, iter) => accum + iter, 0)
  }

  getTotalPrice() {
    return calculatePrice(this.props.value, this.props.price)
  }

  render() {
    const {value, price, checkoutAge} = this.props
    const prices = describePriceAges(price) 

    return  (

      <React.Fragment>
        <div className="agePersonsPickerBar">
          <p>
            总价
          </p>
          <div className="priceTotal">
            <img  src="/static/icon_ticket.svg"/>            
            <p className="totalpersons" > 
              {this.getTotalPersons()}
            </p>
            <img src="/static/icon_price.svg"/>            
            <p className="">{this.getTotalPrice()}€</p>
          </div>
        </div>
        <div className="agePersonsPicker" style={{padding: "5px 10px"}}>

          { 
            prices.map(row => (
              <div 
                key={row.key}
                className="wrapper"
                disabled={!checkoutAge && row.age < 19}
              >
                <div>
                  {value[row.key] || 0}
                </div>
                <div>
                  <div>{row.title}</div>
                  <div>{row.ages}</div>
                  <div>x {row.price}€</div>
                </div>
                <div>
                  <button 
                    disabled={!checkoutAge && row.age < 19}
                    onClick={() => {
                      this.sumContador(row.key, 1)
                    }}
                  >
                    <Plus />
                  </button>
                  <button 
                    disabled={!checkoutAge && row.age < 19}
                    onClick={() => {
                      this.sumContador(row.key, -1)
                    }}
                  >
                    <Minus />
                  </button>
                </div>
              </div>
            ))
          }

        </div>
      </React.Fragment>
    )
  }
}

AgePersonsPicker.propTypes = {
  price: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  checkoutAge: PropTypes.func.isRequired,
  onChange: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.AgePersons.jsx